<div class="list">
  <coa-list-element
    (click)="redirect(floor.id.toString())"
    *ngFor="let floor of elements"
    [chartLabel]="dateRange"
    [chartValue]="floor.offlineTraffic"
    [clientId]="clientId"
    [label]="floor.numberOfStores + ' ' + ('stores included' | translate)"
    [name]="(floor.seriesName !== floorName.UNKNOWN_FLOOR ? 'Floor ' + floor.seriesName : floorName.UNKNOWN_FLOOR)"
    [number]="floor.position"
    [percentageChangeLabel]="'Foot traffic' | translate"
    [percentageChangeValue]="floor.changeInFootTraffic"
    [percentage]="floor?.paymentConversion !== null && floor?.paymentConversion !== undefined ? {label: 'Payment conversion' | translate, value: floor?.paymentConversion} : null"
    [subName]="floor.subName"
    [totalLabel]="'Traffic index' | translate"
    [totalValue]="floor.trafficShare"
    class="list-element"
    data-cy="dasboard-floors.list-element">
  </coa-list-element>
</div>
